import React from "react";
import { Link, useParams } from "react-router-dom";

import { Breadcrumb, Container, Row } from 'react-bootstrap';

import SearchbarPartial from "../partials/SearchbarPartial";
import PreSchoolEduCategoriesPartial from "../partials/PreSchoolEduCategoriesPartial";
import { getLanguageFullName } from "../common/functions";

const LanguageComponent = () => {

  const params = useParams();

  let view 
  switch(params.language){
    case 'wychowanie-przedszkolne' : 
      view = <PreSchoolEduCategoriesPartial language={"wychowanie-przedszkolne"}/>;
      break;
    default : 
      view = <PreSchoolEduCategoriesPartial language={params.language}/>;
      break;
  }


  return(
    <React.Fragment>

      <div className="header">
        <Container className="py-3">
          
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item><Link to="/">Strona główna</Link></Breadcrumb.Item>
              <Breadcrumb.Item active>{getLanguageFullName(params.language)}</Breadcrumb.Item>
            </Breadcrumb> 
          </Row>

          
          <Row>
            <SearchbarPartial language={params.language} />
          </Row>
        </Container>
      </div>
      
      <Container className="languageCategories">
        {view}
      </Container>

    </React.Fragment>
  )

}
export default LanguageComponent;